import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=adf63e6e&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Join.vue?vue&type=style&index=1&id=adf63e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf63e6e",
  null
  
)

export default component.exports